module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAYCAYAAADKx8xXAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEDSURBVHgBndTPTcMwFAbw97kuEreyQUaADcgNhRRlBJgANgBu3BihjGAEinqjI3SEbkDOsdtXJ1L/24nd75Yn/RLL7+WBAnOX61sCEtJ6Np1eLhCC7sf1C0F8bp6x4nTQh7KH5SuAj/0ag65ELyJ+O67bF/0jFtkshkKnOAcp5bicENQe9xx0AGPQFsaiFmZj8wjQJAY1EbYnz7GohQSuHPVRXQ9G1BH7RX53QUjxl2X1tRf+quGMmZ5i8a4d/kuq2KzSsryYO2EsPh25QOwe8gDs/616cOfq8GEm/u7cAOWP/PK0ioKWVZ6bws7YhJve2qNKoW+CYJOi4MSQSSTJuVKo1uMWnhxaQEQhAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/priceCard/left.png
// module id = /+pU
// module chunks = 1